import Avatar from '@mui/material/Avatar'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const Root = styled('button')`
  background: none;
  border: none;
  padding: 0;
`

export const UserProfileButton = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`

export const UserProfilePopoverInner = styled('div')`
  padding: 12px 16px;
  width: 226px;
`

export const UserProfilePopoverMenu = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const UserProfilePopoverLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  color: auto;
`
export const UserProfilePopoverLinkText = styled(Typography)`
  margin-left: 10px;
  color: ${colors.bodyText};
`

export const StyledPendoGuideIcon = styled('div')`
  width: 28.5px;
  height: 28.5px;
  background-color: ${colors.primary};
  margin-right: 16px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;

  &::before {
    content: '?';
    font-weight: 700;
    font-size: 20px;
    position: absolute;
    color: #fff;
    left: 50%;
    bottom: 2px;
    transform: translateX(-50%);
  }
`
